import client from "../index";
import { GET_CAMPAIGN, GET_CAMPAIGNS, GET_CAMPAIGNS_LIGHT, GET_CAMPAIGN_CONTACT_LIFECYCLES, GET_SENDER_ADDRESSES } from "./query";
import {
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  STOP_CAMPAIGN,
  DELETE_CAMPAIGN,
  SEND_CAMPAIGN,
  REQUEST_SENDER_VERIFICATION,
} from "./mutation";

export const apiGetCampaign = async (id) => {
  const result = await client.query({
    query: GET_CAMPAIGN,
    variables: { id },
    fetchPolicy: "network-only",
  });
  return result?.data?.campaign || null;
};

export const apiGetCampaigns = async (input = {}) => {
  const result = await client.query({
    query: GET_CAMPAIGNS,
    variables: { input },
    fetchPolicy: "network-only",
  });
  return result?.data?.campaigns || { total: 0, campaigns: [] };
};

// Same as apiGetCampaigns without `data`; the row's data is fetched by
// apiGetCampaign when it is selected.
export const apiGetCampaignsLight = async (input = {}) => {
  const result = await client.query({
    query: GET_CAMPAIGNS_LIGHT,
    variables: { input },
    fetchPolicy: "network-only",
  });
  return result?.data?.campaigns || { total: 0, campaigns: [] };
};

export const apiCreateCampaign = async (input) => {
  const result = await client.mutate({
    mutation: CREATE_CAMPAIGN,
    variables: { input },
  });
  return result?.data?.createCampaign?.campaign || null;
};

export const apiUpdateCampaign = async (input) => {
  const result = await client.mutate({
    mutation: UPDATE_CAMPAIGN,
    variables: { input },
  });
  return result?.data?.updateCampaign?.campaign || null;
};

export const apiDeleteCampaign = async (id) => {
  const result = await client.mutate({
    mutation: DELETE_CAMPAIGN,
    variables: { id },
  });
  return result?.data?.deleteCampaign || null;
};

export const apiStopCampaign = async (id) => {
  const result = await client.mutate({
    mutation: STOP_CAMPAIGN,
    variables: { id },
  });
  return result?.data?.stopCampaign?.campaign || null;
};

// Lifecycle rows change every time a campaign is (dry-)sent, so always hit the
// network rather than serving a stale cache.
export const apiGetCampaignContactLifecycles = async (input = {}) => {
  const result = await client.query({
    query: GET_CAMPAIGN_CONTACT_LIFECYCLES,
    variables: { input },
    fetchPolicy: "network-only",
  });
  return result?.data?.campaignContactLifecycles || { total: 0, items: [] };
};

// dryRun defaults to true server-side; the UI always passes it explicitly so a
// campaign is only ever simulated (recipients marked, no email sent).
export const apiSendCampaign = async (input) => {
  const result = await client.mutate({
    mutation: SEND_CAMPAIGN,
    variables: { input },
  });
  return result?.data?.sendCampaign || null;
};

export const apiGetSenderAddresses = async (domain) => {
  const result = await client.query({
    query: GET_SENDER_ADDRESSES,
    variables: { domain },
    fetchPolicy: "network-only",
  });
  return result?.data?.senderAddresses || [];
};

export const apiRequestSenderVerification = async ({ domain, email }) => {
  const result = await client.mutate({
    mutation: REQUEST_SENDER_VERIFICATION,
    variables: { input: { domain, email } },
    fetchPolicy: "no-cache",
  });
  return result?.data?.requestSenderVerification || null;
};
